module.exports = __webpack_public_path__ + "img/svg/wood-trunk-a0845890.svg";